import { converter } from '../Images/Imager';
import { useContext } from 'react';
import { ContextStorage } from '../Storage/ContextStorage';


const ImageConverter = (props) => {

    const { setProjectDisplay, setProjectObj } = useContext(ContextStorage);
    const { scroll } = props;

    const handleProjectClick = () => {
        setProjectObj({
            title: 'Image Converter',
            description: 'A simple image converter built with vanilla JS, Electron and Sharp. Developed for windows 10 / 11 64-bit.',
            technologies: "Electron, Sharp, JavaScript",
            media: converter,
            link: '',
            downloadURL: 'ImageConverter/Converter.7z'
        })
        scroll(true);
        setProjectDisplay(true);

    }

    return (
        <div className="project-container" onClick={() => {handleProjectClick()}}>
            <div className='project-image-container'>
                <img src={converter} alt="brand logo"/>
            </div>
            <div className='project-textbox'>
                <h4>Image Converter</h4>
                <p>Quickly convert any image to different formats.</p>
            </div>
        </div>
    )
}

export { ImageConverter };